export default __webpack_public_path__ + "static/messaging-landing-7e165f17e2dba36488e87bef8c48eedf.png";